import { useQuery } from '@tanstack/react-query'

import { ClientLocationVaccinesService } from '@services/client_location_vaccines.service'
import { APILocationVaccineClientDtoResponse } from '../types/api'
import { DEFAULT_CACHE_TIME, defaultQueryOptions } from './common'

export const useClientLocationVaccines = (locationName: string, options?: { cacheEnabled?: boolean }) => {
  const { cacheEnabled = false } = options || {}
  return useQuery<APILocationVaccineClientDtoResponse>({
    queryKey: ['clientLocationVaccines', locationName],
    queryFn: () => ClientLocationVaccinesService.list(locationName),
    ...defaultQueryOptions,
    ...(cacheEnabled ? { staleTime: DEFAULT_CACHE_TIME, cacheTime: DEFAULT_CACHE_TIME } : {}),
  })
}
